<template>
  <div id="modemSearchPopup">
    <div class="common_list_wrap">
      <div class="common_list_middle">
        <div class="common_list_head">
          <div><span>이동전화번호</span></div>
          <div><span>등록번호</span></div>
          <div><span>사유</span></div>
          <div><span>처리일</span></div>
        </div>
        <div class="common_list_body">
          <div :key="'modem_' + index" v-for="(item, index) in list">
            <div><span>{{item.mobileNum || item.mobile_num}}</span></div>
            <div><span>{{item.registryNum || item.registry_num}}</span></div>
            <div><span>{{item.reason}}</span></div>
            <div><span>{{item.regDate}}</span></div>
          </div>
        </div>
      </div>
      <div class="common_bottom_wrap padding_wrap">
        <div class="btn_bottom btn_close" @click="hidePopup">닫기</div>
      </div>
    </div>
  </div>
</template>

<script>
import common from '../../script/common'
import { defaultLoadingOptions } from '../../script/defaultConfig'
import modemStop from '../../script/modemStop'

export default {
  props: ['popupParams'],
  data () {
    return {
      list: []
    }
  },
  mounted () {
    common.getSession(response => {
      if (response.data.resultCode === 1 && response.data.result != null && response.data.result.userPid != null && response.data.result.userRole != null) {
        this.updateList()
      } else {
        common.amsAlert('general', '로그아웃 되었습니다.\n다시 로그인해주세요.')
        this.$router.replace('/Login')
      }
    })
  },
  methods: {
    hidePopup (args) {
      this.$emit('hidePopup', args)
    },
    updateList () {
      let filter = {}
      if (this.popupParams.data.from === 'STOP') {
        filter.stopGroupPid = this.popupParams.data.stopGroupPid
      } else if (this.popupParams.data.from === 'CANCEL') {
        filter.csGroupPid = this.popupParams.data.csGroupPid
      }
      let vueLoadingOverlay = this.$loading.show(defaultLoadingOptions)
      modemStop.stopDesc(filter, response => {
        console.log('모뎀 실패 사유', response)
        vueLoadingOverlay.hide()
        if (response.data.resultCode === 1) {
          this.list = response.data.result.body
        } else {
          common.amsAlert('retry', '실패 사유를 불러오지 못했습니다.')
          this.list = []
        }
      })
    }
  }
}
</script>

<style scoped>
#modemSearchPopup .common_list_wrap {
  width: 100%;
  margin-top: 25px;
}

#modemSearchPopup .common_list_wrap > .common_list_middle {
  margin-top: 10px;
}

#modemSearchPopup .common_list_middle > .common_list_head,
#modemSearchPopup .common_list_middle > .common_list_body {
  width: 100%;
}

#modemSearchPopup .common_list_middle > .common_list_head > div {
  background: #F8F8F8;
}

#modemSearchPopup .common_list_middle > .common_list_body > div:nth-child(odd) {
  background: #FFFFFF;
}

#modemSearchPopup .common_list_middle > .common_list_body > div:nth-child(even) {
  background: #F8F8F8;
}

#modemSearchPopup .common_list_middle > .common_list_head > div,
#modemSearchPopup .common_list_middle > .common_list_body > div > div {
  flex-shrink: 0;
  width: 15%;
}

#modemSearchPopup .common_list_middle > .common_list_head > div:nth-child(3),
#modemSearchPopup .common_list_middle > .common_list_body > div > div:nth-child(3) {
  flex-shrink: 1;
  width: 100%;
  word-break: break-all;
}

#modemSearchPopup .common_list_middle > .common_list_body > div > div {
  color: #36414F;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
}

#modemSearchPopup .common_bottom_wrap > .btn_bottom {
  height: 46px;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 46px;
}

#modemSearchPopup .common_bottom_wrap > .btn_close {
  width: 76px;
  margin: auto auto auto 0;
  color: #36414F;
}
</style>



// WEBPACK FOOTER //
// src/components/common/FailedDescPopup.vue